/**
 * This file was copied from dashboard into clowncar as part of a cleanup effort
 */
import { Link } from 'react-router-dom';
import { LocalDate } from 'js-joda';
import { clone, concat, find, isEqual, map, remove } from 'es-toolkit/compat';

import { DisplayDate } from '@tock/time';
import { dashboard } from 'types';

export function addOrReplaceDate(selectedDates: LocalDate[], newDate: LocalDate) {
  let currentDates = clone(selectedDates);
  if (find(currentDates, (date) => isEqual(date, newDate))) {
    remove(currentDates, (date) => isEqual(date, newDate));
  } else {
    currentDates = concat(currentDates, newDate);
  }
  return currentDates;
}

interface IOptions {
  linkToCalendar?: boolean;
}

export function getDesiredDateDisplay(
  dateRanges: dashboard.WaitlistReportRow.IDateRange[],
  options?: IOptions
): JSX.Element[] {
  const dateElements = map(dateRanges, (dateRange) => {
    if (dateRange.datePair && dateRange.datePair.startDate && dateRange.datePair.endDate) {
      if (options && options.linkToCalendar) {
        return (
          <span>
            <Link to={`/app/${dateRange.datePair.startDate}/calendar/day`}>
              <DisplayDate dateValue={dateRange.datePair.startDate} displayYearAs="2-digit" />
            </Link>{' '}
            -{' '}
            <Link to={`/app/${dateRange.datePair.endDate}/calendar/day`}>
              <DisplayDate dateValue={dateRange.datePair.endDate} displayYearAs="2-digit" />
            </Link>
          </span>
        );
      } else {
        return (
          <span>
            <DisplayDate dateValue={dateRange.datePair.startDate} displayYearAs="2-digit" /> -{' '}
            <DisplayDate dateValue={dateRange.datePair.endDate} displayYearAs="2-digit" />
          </span>
        );
      }
    } else if (dateRange.date) {
      if (options && options.linkToCalendar) {
        return (
          <Link to={`/app/${dateRange.date}/calendar/day`}>
            <DisplayDate dateValue={dateRange.date} displayYearAs="2-digit" />
          </Link>
        );
      } else {
        return <DisplayDate dateValue={dateRange.date} displayYearAs="2-digit" />;
      }
    } else {
      return [];
    }
  });
  // Renders the elements in a list with a comma
  return map(dateElements, (row, key) => (
    <span>
      {row}
      {key === dateElements.length - 1 ? '' : ', '}
    </span>
  ));
}
